module.exports = __webpack_public_path__ + "img/role04.e5c1746f.png";